<template>
  <div class="paypal-button-render" :id="`paypal-button-render-${only_render_id}`" ref="paypalId"></div>
</template>
<script>
import mixProperties from '@/js/mixins/mixProperties'
export default {
  props: { addproduct: {}, add_cart_list: {}, cartmes: {}, group_checked_variants_info: {} },
  mixins: [mixProperties],
  data() {
    return {
      only_render_id: this.randomCoding(6),
      payload: {
        env: window.smart_button_sandbox ? 'sandbox' : 'production',
        locale: 'en_US',
        style: {
          layout: window.smart_button_paypal_layout == 'yes_vertical' ? 'vertical' : 'horizontal',
          color: 'gold',
          shape: 'rect',
          size: 'responsive',
          height: 48,
          label: location.pathname.includes('/products/') ? 'pay' : 'paypal',
          tagline: false,
        },
      },
      payment_method: window.smart_button_preferred_paypal_payment_method,
    }
  },
  methods: {
    statis_event(name = '', parameters = {}) {
      axios.post('/api/statistics/events', {
        name,
        parameters: {
          cart_hash: window.getCookie('cart_hash'),
          url: window.location.href,
          paypalType: this.payment_method,
          ...parameters,
        },
      })
    },
    async ppCreateOrder() {
      let statis_data = { verify: true }
      try {
        let addproduct = this.addproduct //data包括quantity,product_id，和变种id
        let add_cart_list = this.add_cart_list //athena主题power加购是多个商品
        let group_checked_variants_info = this.group_checked_variants_info //athena主题组合商品加购是多个商品
        let cartmes = null
        let cart_item = []
        cartmes = this.cartmes
        if (cartmes) cartmes = JSON.parse(cartmes)
        if (add_cart_list) {
          add_cart_list = JSON.parse(add_cart_list)
        } else {
          add_cart_list = []
        }
        if (group_checked_variants_info) {
          group_checked_variants_info = JSON.parse(group_checked_variants_info)
        } else {
          group_checked_variants_info = []
        }
        if (cartmes && cartmes.cart) cart_item = Object.values(cartmes.cart)
        if (addproduct) {
          let customFormProperties = this.mixProperties()
          let payload = {}
          let api = '/api/store/cart'
          payload = JSON.parse(addproduct)
          payload.quantity = payload.quantity || 1
          payload.addType = 'product.add.paypal'
          let filesOff = false
          if (customFormProperties) {
            let { files, properties, resume } = customFormProperties
            if (!resume) {
              return
            }
            filesOff = files && Object.keys(files).length
            let propertiesOff = properties && Object.keys(properties).length
            if (filesOff) {
              payload = parseFormDate('properties', files, properties, payload)
            } else if (propertiesOff) {
              payload.properties = properties
            }
          }
          if (
            (add_cart_list && add_cart_list.length) ||
            (group_checked_variants_info && group_checked_variants_info.length)
          ) {
            if (!add_cart_list || !add_cart_list.length) add_cart_list = [{ ...JSON.parse(addproduct) }]
            api = '/api/store/batchCart'
            payload = {
              payload: 'product.batch.paypal',
              product: [],
            }
            let formData = new FormData()
            let filesOff = false

            if (customFormProperties) {
              let { files, properties } = customFormProperties
              filesOff = files && Object.keys(files).length
              let propertiesOff = properties && Object.keys(properties).length
              if (filesOff) {
                add_cart_list.forEach((item, index) => {
                  console.log(item, 'item', index)
                  formData = parseFormDate(
                    `product[${index}][properties]`,
                    files,
                    properties,
                    item,
                    `product[${index}]`,
                    formData
                  )
                })
              } else if (propertiesOff) {
                add_cart_list = add_cart_list.map((item) => {
                  return { ...item, properties: properties }
                })
              }
            }
            if (filesOff) {
              let add_cart_list_length = add_cart_list.length
              group_checked_variants_info.forEach((item, index) => {
                for (const key in item) {
                  if (Object.hasOwnProperty.call(item, key)) {
                    formData.append(`product[${add_cart_list_length + index}][${key}]`, item[key])
                  }
                }
              })
              payload = formData
            } else {
              payload.product.push(...add_cart_list, ...group_checked_variants_info)
            }
          }
          if (filesOff) {
            payload.append('clear', 1)
          } else {
            payload.clear = true
          }
          cartmes = await axios.post(api, payload)
          cartmes = cartmes.data
          cart_item = Object.values(cartmes.cart)
          if (window.fbq) {
            window.send_fb_event('AddToCart', {
              content_type: 'product_group',
              content_ids: cart_item.map((item) => item?.product_id),
              value: cartmes.cart_total,
              num_items: cartmes.cart_contents_count,
              content_name: cart_item.map((item) => item?.product?.post_title),
              currency: cartmes.currency || 'USD',
              content_category: cart_item.map((item) => item?.category_ids),
            })
          }
          if (window.ttq) {
            window.send_ttp_event('AddToCart', {
              content_id: cart_item.map((item) => item?.product_id),
              quantity: cartmes.cart_contents_count,
              value: cartmes.cart_total,
              currency: window.checkoutcurrency || 'USD',
            })
          }

          if (window._learnq) {
            window._learnq.push([
              'track',
              'Added to Cart',
              {
                AddedItemProductName: cart_item.map((item) => item?.product?.post_title),
                AddedItemProductID: cart_item.map((item) => item?.product_id),
                AddedItemSKU: cart_item.map((item) => item?.sku),
                AddedItemCategories: cart_item.map((item) => item?.category_ids),
                AddedItemURL: cart_item.map((item) => item?.public_url),
                AddedItemPrice: cartmes.cart_total,
                AddedItemQuantity: cartmes.cart_contents_count,
              },
            ])
          }
        }
        if (window._learnq && cartmes) {
          const { hash, cart_total, cart } = cartmes
          let items = []
          let name = []
          if (cart && cart.length) {
            Object.values(cart).forEach((item) => {
              const obj = {
                ProductID: item.product.ID,
                SKU: item.product.sku,
                ProductName: item.product.post_title,
                Quantity: item.quantity,
                ItemPrice: item.product.price,
                RowTotal: item.line_total,
                ProductURL: item.product.public_url,
                ImageURL: item.product.feature_image && item.product.feature_image.url,
                // "ProductCategories": ["Fiction", "Children"]
              }
              name.push(item.product.post_title)
              items.push(obj)
            })
            window._learnq.push([
              'track',
              'Started Checkout',
              {
                $event_id: hash,
                $value: cart_total,
                ItemNames: name,
                // "Categories": ["Fiction", "Children", "Classics"],
                Items: items,
              },
            ])
          }
        }
        if (window.fbq && cartmes && cart_item.length) {
          window.send_fb_event('InitiateCheckout', {
            content_type: 'product_group',
            content_ids: cart_item.map((item) => item?.product_id),
            value: cartmes.cart_total,
            num_items: cartmes.cart_contents_count,
            content_name: cart_item.map((item) => item?.product?.post_title),
            currency: cartmes.currency || 'USD',
          })
        }
        if (window.ttq && window.send_ttp_event) {
          window.send_ttp_event('InitiateCheckout')
        }
        let pathname = window.location.pathname
        let payload = {}
        if (pathname.includes('/checkouts') && pathname.split('/')[2]) {
          payload['cart_hash'] = pathname.split('/')[2]
        }
        let res1 = await axios.post('/api/store/cart/start_checkout', payload)
        return (this.payment_method == 'paypal_rest'|| this.payment_method == 'paypal_cluster_rest') ? res1.data.id : res1.data.token
      } catch (error) {
        statis_data.verify = false
        statis_data.error = error?.message || error?.response?.data?.message
        let body = document.getElementsByTagName('body')[0]
        var message = error?.response?.data?.message
        if (error.response && error.response.data && error.response.data.errors) {
          message = Object.values(error.response.data.errors)[0][0]
        }
        var div = document.createElement('div')
        div.innerHTML = `
                <div role="alert" class="el-message el-message--error" style="top: 20px; z-index: 2002;"><i class="el-message__icon el-icon-error"></i><p class="el-message__content">${message}</p></div>`
        body.append(div)
        setTimeout(() => {
          body.removeChild(div)
        }, 4000)
      } finally {
        this.statis_event('checkout.paypal.authorize', statis_data)
      }
    },
    ppOnAuthorize(data, actions) {
      this.statis_event('checkout.paypal.approve')
      document.cookie = `paypalApprove=success;path=/;expires=Fri, 31 Dec 9999 23:59:59 GMT`
      return actions.redirect()
    },
    async ppOnApprove(data, actions) {
      let statis_data = { verify: true }
      try {
        let payload = {
          paypalOrderId: data.orderID,
        }
        let res = await axios.post('/api/store/cart/approve_checkout', payload)
        document.cookie = `paypalApprove=success;path=/;expires=Fri, 31 Dec 9999 23:59:59 GMT`
        location.href = res.data.redirect
      } catch (error) {
        statis_data.verify = false
        statis_data.error = error?.message || error?.response?.data?.message
      } finally {
        this.statis_event('checkout.paypal.approve', statis_data)
      }
    },
    ppOnError(error) {
      this.statis_event('checkout.paypal.authorize.failed', { error: error.message })
    },
    ppOnCancel() {
      this.statis_event('checkout.paypal.cancel')
    },
    readerPaypal() {
      let payload = {
        ...this.payload,
        onError:this.ppOnError,
        onCancel:this.ppOnCancel,
      }
      if (this.payment_method == 'paypal_rest') {
        payload['createOrder'] = this.ppCreateOrder
        payload['onApprove'] = this.ppOnApprove
        paypal.Buttons(payload).render(`#paypal-button-render-${this.only_render_id}`)
      } else if (this.payment_method == 'paypal_cluster_rest') {
        payload['payment'] = this.ppCreateOrder
        payload['onAuthorize'] = this.ppOnApprove
        paypal.Button.render(payload, `#paypal-button-render-${this.only_render_id}`)
      } else {
        payload['payment'] = this.ppCreateOrder
        payload['onAuthorize'] = this.ppOnAuthorize
        paypal.Button.render(payload, `#paypal-button-render-${this.only_render_id}`)
      }
    },
  },
  mounted() {
    if (!window.smart_button_enable) return
    let timestamp = 1
    document.addEventListener('keydown', ($event) => {
      let { keyCode } = $event
      if (keyCode == 9) {
        timestamp = new Date().getTime()
      }
    })
    window.addEventListener('blur', ($event) => {
      setTimeout(() => {
        //如果是tab触发的失焦 则忽略不需要发送该事件
        const { src, className, title } = document.activeElement
        const isPaypal = title?.toLowerCase()?.includes('paypal') || title?.toLowerCase()?.includes('paypal')
        if (new Date().getTime() - timestamp < 100 || !isPaypal) return
        //由于document.activeElement聚焦到了iframe上  会导致原文档失去焦点 即可触发该事件
        if (document.activeElement instanceof HTMLIFrameElement) {
          let { src, className, title } = document.activeElement
          this.statis_event('checkout.paypal.native.click', {
            iframeSrc: src,
            className,
            title,
          })
          document.activeElement.blur()
        }
      }, 10)
    })
    const t = () => {
      if (typeof paypal != 'undefined') {
        this.$nextTick(this.readerPaypal)
      } else {
        setTimeout(t, 500)
      }
    }
    t()
  },
}
</script>
<style scoped lang='scss'>
.paypal-button-render {
  position: relative;
  z-index: 1;
  .aaa {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 999;
  }
}
</style>
